import { clearSessions } from "../utils/auth.js";

class SonikitPlayer extends HTMLElement {
  #shadow

  constructor() {
    super();
    this.#shadow = this.attachShadow({ mode: 'closed' });

    const template = document.createElement('template');
    template.innerHTML = `
      <style>
        .wrapper {
          position: fixed;
          bottom: 10px;
          left: 0;
          right: 0;
          margin: auto;
          width: 95%;
          padding: 10px;
          box-sizing: border-box;
          background-color: rgba(0,0,0,0.5);
          backdrop-filter: blur(10px);
          border-radius: 10px;
          color: white;
          transition: height 500ms ease;
          font-family: Arial, Helvetica, sans-serif;
          user-select: none;
        }

        .player {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 200ms ease 500ms;
        }
        .wrapper[data-expanded="true"] .player{
          opacity: 0;
          height: 0;
          pointer-events: none;
          transition: all 200ms ease 0ms;
        }

        .preview {
          display: flex;
          gap: 10px;
          flex: 1 1 auto;
        }
        .artwork {
          position: relative;
          width: 50px;
          height: 50px;
          background-color: grey;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          overflow: hidden;
        }
        .artwork img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: none;
        }
        .wrapper[data-status="ready"] .artwork img,
        .wrapper[data-status="playing"] .artwork img,
        .wrapper[data-status="paused"] .artwork img{
          display: block;
        }

        .error-icon {
          width: 20px;
          height: 20px;
          fill: white;
          display: none;
        }
        .wrapper[data-status="error"] .error-icon{
          display: block;
        }

        .loader {
          width: 20px;
          height: 20px;
          fill: white;
          animation: rotate 2s linear infinite;
          display: none;
        }
        .wrapper[data-status="loading"] .loader{
          display: block;
        }
        .loader circle {
          stroke: #FFFFFF;
          stroke-linecap: round;
          animation: dash 1.5s ease-in-out infinite;
        }
        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes dash {
          0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
          }
          50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
          }
          100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 4px;
        }
        .title {
          font-size: 0.9em;
        }
        .subtitle {
          opacity: 0.5;
          font-size: 0.9em;
        }


        .controls {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 20px;
          padding-right: 10px;
          box-sizing: border-box;
        }
        .controls button{
          background: transparent;
          border: none;
          outline: none;
          padding: 0;
          margin: 0;
          cursor: pointer;
        }
        .controls svg{ fill: white; pointer-events: none; }
        .controls button[data-action="seek-prev"] { width: 12px; height: 12px; }
        .controls button[data-action="seek-next"] { width: 12px; height: 12px; }
        @media (max-width: 800px) {
          .controls button[data-action="seek-prev"] { display: none; }
          .controls button[data-action="seek-next"] { display: none; }
        }

        .controls button[data-action="toggle-playback"] { width: 36px; height: 36px; }

        [data-action="toggle-playback"] svg[data-icon="pause"] { display: none; }
        .wrapper[data-status="paused"] [data-action="toggle-playback"] svg[data-icon="play"] { display: block; }
        .wrapper[data-status="playing"] [data-action="toggle-playback"] svg[data-icon="play"] { display: none; }
        .wrapper[data-status="playing"] [data-action="toggle-playback"] svg[data-icon="pause"] { display: block; }


        .card {
          height: 0;
          width: 100%;
          opacity: 0;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          transition: all 300ms ease;
          pointer-events: none;
        }
        .wrapper[data-expanded="true"] .card{
          height: 400px;
          opacity: 1;
          transition: all 300ms ease;
          pointer-events: auto;
        }

        .card__nav {
          width: 100%;
          padding: 8px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.8em;
        }
        .card__nav button{ 
          padding: 0;
          margin: 0;
          background: transparent;
          border: none;
          outline: none;
          color: white;
          cursor: pointer;
        }
        .card__nav svg{
          width: 20px;
          height: 20px;
          fill: white;
          pointer-events: none;
        }
        .card[data-menu-active="false"] [data-action="open-menu"]{
          display: block;
        }
        .card[data-menu-active="false"] [data-action="close-menu"]{
          display: none;
        }
        .card[data-menu-active="true"] [data-action="open-menu"]{
          display: none;
        }
        .card[data-menu-active="true"] [data-action="close-menu"]{
          display: block;
        }

        .card__content {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;
        }

        .card__preview {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 20px;
          opacity: 1;
          transition: opacity 300ms ease;
        }
        .card[data-menu-active="true"] .card__preview{
          opacity: 0;
          pointer-events: none;
          transition: opacity 300ms ease;
        }

        .card__artwork {
          position: relative;
          width: 180px;
          height: 180px;
          border-radius: 10px;
          overflow: hidden;
          background-color: grey;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .card__artwork img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: none;
        }
        .wrapper[data-status="ready"] .card__artwork img,
        .wrapper[data-status="playing"] .card__artwork img,
        .wrapper[data-status="paused"] .card__artwork img{
          display: block;
        }

        .card__info {
          width: 180px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 6px;
        }
        .card__subtitle {
          opacity: 0.5;
          font-size: 0.8em;
        }

        .card__controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 180px;
        }
        .card__controls button{ 
          background: transparent;
          border: none;
          outline: none;
          padding: 0;
          margin: 0;
          cursor: pointer;
          opacity: 1;
          transition: opacity 300ms ease;
        }
        .card__controls svg{ fill: white; pointer-events: none; }
        .card__controls button[data-action="seek-prev"] { width: 18px; height: 18px; }
        .card__controls button[data-action="seek-next"] { width: 18px; height: 18px; }
        .card__controls button[data-action="toggle-playback"] { width: 46px; height: 46px; }
        .card__controls button svg[data-icon="pause"] { display: none; }

        .card[data-menu-active="true"] .card__controls{
          opacity: 0;
          pointer-events: none;
          transition: opacity 300ms ease;
        }

        .card__menu {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          pointer-events: none;
          transition: opacity 300ms ease;
        }
        .card[data-menu-active="true"] .card__menu{
          opacity: 1;
          pointer-events: all;
          transition: opacity 300ms ease;
        }

        .card__menu ul{
          list-style: none;
          margin: 0;
          padding: 0;
          text-align: center
        }
        .card__menu ul a{
          text-decoration: none;
          color: white;
        }
        .card__menu li {
          font-size: 1.4em;
          margin: 24px auto;
          cursor: pointer;
        }

        .player-error-close {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          font-size: 0.8em;
        }
        .player-error-close svg{
          width: 1em;
          height: 1em;
        }
      </style>
      <div class="wrapper" data-status="loading">
        <div class="player">
          <div class="preview">
            <div class="artwork">
              <svg class="loader" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>
              <svg class="error-icon" className='icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960"><path d="M479.982 776q14.018 0 23.518-9.482 9.5-9.483 9.5-23.5 0-14.018-9.482-23.518-9.483-9.5-23.5-9.5-14.018 0-23.518 9.482-9.5 9.483-9.5 23.5 0 14.018 9.482 23.518 9.483 9.5 23.5 9.5ZM453 623h60V370h-60v253Zm27.266 353q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80 658.319 80 575.5q0-82.819 31.5-155.659Q143 347 197.5 293t127.341-85.5Q397.681 176 480.5 176q82.819 0 155.659 31.5Q709 239 763 293t85.5 127Q880 493 880 575.734q0 82.734-31.5 155.5T763 858.316q-54 54.316-127 86Q563 976 480.266 976Zm.234-60Q622 916 721 816.5t99-241Q820 434 721.188 335 622.375 236 480 236q-141 0-240.5 98.812Q140 433.625 140 576q0 141 99.5 240.5t241 99.5Zm-.5-340Z"/></svg>
              <img src='' />
            </div>
            <div class="info">
              <div class="title">Player loading...</div>
              <div class="subtitle"></div>
            </div>
          </div>
          <div class="controls">
            <button data-role="player-control" data-action="seek-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M99.8,500H12.2V0H99.8Zm0-250,388,250V0Z"/></svg></button>
            <button data-role="player-control" data-action="toggle-playback">
              <svg data-icon="play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M174.6,363.4V136.6L371.1,250ZM250,500A250,250,0,0,1,73.2,73.2,250,250,0,0,1,426.8,426.8,248.4,248.4,0,0,1,250,500Zm0-479.8A229.8,229.8,0,0,0,87.5,412.5a229.8,229.8,0,0,0,325-325A228.3,228.3,0,0,0,250,20.2Z"/></svg>
              <svg data-icon="pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M250,500A250,250,0,0,1,73.2,73.2,250,250,0,0,1,426.8,426.8,248.4,248.4,0,0,1,250,500Zm0-479.8A229.8,229.8,0,0,0,87.5,412.5a229.8,229.8,0,0,0,325-325A228.3,228.3,0,0,0,250,20.2ZM222.5,142h-40V358h40Zm95,0h-40V358h40Z"/></svg>
            </button>
            <button data-role="player-control" data-action="seek-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M400.2,0h87.6V500H400.2Zm0,250L12.2,0V500Z"/></svg></button>
          </div>
        </div>
        <div class="card" data-menu-active="false">
          <div class="card__nav">
            <button data-role="card-nav-button" data-action="collapse">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><polygon points="250 391.4 0 141.4 32.8 108.6 250 325.9 467.2 108.7 500 141.4 250 391.4"/></svg>
            </button>
            <div class="nav__service-label">
              Playing from ${sonikit.player.service.display_name}
            </div>
            <button data-role="card-nav-button" data-action="open-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M-.1,250a64.3,64.3,0,1,1,64.3,64.3A64.3,64.3,0,0,1-.1,250ZM250,314.3A64.3,64.3,0,1,0,185.7,250,64.3,64.3,0,0,0,250,314.3Zm185.8,0A64.3,64.3,0,1,0,371.5,250,64.3,64.3,0,0,0,435.8,314.3Z"/></svg>
            </button>
            <button data-role="card-nav-button" data-action="close-menu">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M278.3,250,498.7,470.4l-28.3,28.3L250,278.3,29.6,498.7,1.3,470.4,221.7,250,1.3,29.6,29.6,1.3,250,221.7,470.4,1.3l28.3,28.3Z"/></svg>
            </button>
          </div>
          <div class="card__content">
            <div class="card__preview">
              <div class="card__artwork">
                <svg class="loader" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>
                <svg class="error-icon" className='icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 96 960 960"><path d="M479.982 776q14.018 0 23.518-9.482 9.5-9.483 9.5-23.5 0-14.018-9.482-23.518-9.483-9.5-23.5-9.5-14.018 0-23.518 9.482-9.5 9.483-9.5 23.5 0 14.018 9.482 23.518 9.483 9.5 23.5 9.5ZM453 623h60V370h-60v253Zm27.266 353q-82.734 0-155.5-31.5t-127.266-86q-54.5-54.5-86-127.341Q80 658.319 80 575.5q0-82.819 31.5-155.659Q143 347 197.5 293t127.341-85.5Q397.681 176 480.5 176q82.819 0 155.659 31.5Q709 239 763 293t85.5 127Q880 493 880 575.734q0 82.734-31.5 155.5T763 858.316q-54 54.316-127 86Q563 976 480.266 976Zm.234-60Q622 916 721 816.5t99-241Q820 434 721.188 335 622.375 236 480 236q-141 0-240.5 98.812Q140 433.625 140 576q0 141 99.5 240.5t241 99.5Zm-.5-340Z"/></svg>
                <img src='' />
              </div>
              <div class="card__info">
                <div class="card__title">Player loading...</div>
                <div class="card__subtitle"></div>
              </div>
            </div>
            <div class="card__controls">
              <button data-role="player-control" data-action="seek-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M99.8,500H12.2V0H99.8Zm0-250,388,250V0Z"/></svg></button>
              <button data-role="player-control" data-action="toggle-playback">
                <svg data-icon="play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M174.6,363.4V136.6L371.1,250ZM250,500A250,250,0,0,1,73.2,73.2,250,250,0,0,1,426.8,426.8,248.4,248.4,0,0,1,250,500Zm0-479.8A229.8,229.8,0,0,0,87.5,412.5a229.8,229.8,0,0,0,325-325A228.3,228.3,0,0,0,250,20.2Z"/></svg>\
                <svg data-icon="pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M250,500A250,250,0,0,1,73.2,73.2,250,250,0,0,1,426.8,426.8,248.4,248.4,0,0,1,250,500Zm0-479.8A229.8,229.8,0,0,0,87.5,412.5a229.8,229.8,0,0,0,325-325A228.3,228.3,0,0,0,250,20.2ZM222.5,142h-40V358h40Zm95,0h-40V358h40Z"/></svg>
              </button>
              <button data-role="player-control" data-action="seek-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><path d="M400.2,0h87.6V500H400.2Zm0,250L12.2,0V500Z"/></svg></button>
            </div>

            <div class="card__menu">
              <ul>
                <li>View on ${sonikit.player.service.display_name}</li>
                <li data-action="disconnect">Disconnect Player</li>
                <li><a href="https://www.sonikit.com?utm_source=sonikitjs&utm_medium=referral&utm_campaign=embed&utm_id=${sonikit.player.patch.id}" target="_blank" rel="noreferrer">Powered by Sonikit</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    `

    this.#shadow.appendChild(template.content.cloneNode(true));

    const wrapper = this.#shadow.querySelector('.wrapper');
    const artworkImage = wrapper.querySelector('.artwork img');
    const title = wrapper.querySelector('.title');
    const subtitle = wrapper.querySelector('.subtitle');
    const cardArtworkImage = wrapper.querySelector('.card__artwork img');
    const cardTitle = wrapper.querySelector('.card__title');
    const cardSubtitle = wrapper.querySelector('.card__subtitle');
    const controls = wrapper.querySelector('.controls');

    sonikit.on('playerStateChanged', (data) => {
      if (wrapper.dataset.status === 'disconnected') return;
      wrapper.dataset.status = data.state;
    })

    sonikit.on('playerTrackChanged', (track) => {
      if (wrapper.dataset.status === 'disconnected') return;

      if (wrapper.dataset.status === 'loading') {
        wrapper.dataset.status = 'ready';
      }
      
      this.artwork = track.image_url;
      artworkImage.src = track.image_url;
      title.innerHTML = track.title;
      subtitle.innerHTML = track.artist;
      cardArtworkImage.src = track.image_url;
      cardTitle.innerHTML = track.title;
      cardSubtitle.innerHTML = track.artist;
    })

    sonikit.on('playerError', (e) => {
      wrapper.dataset.status = 'error';
      title.innerHTML = e.detail.message;
      controls.innerHTML = "";

      // const error_close = document.createElement('div');
      // error_close.classList = 'player-error-close';
      // error_close.innerHTML = `${getIcon('close')} CLOSE`;
      // error_close.addEventListener('click', () => {
      //   wrapper.remove();
      // })

      // controls.appendChild(error_close);
    })

    const preview = wrapper.querySelector('.preview')
    preview.addEventListener('click', () => {
      if (wrapper.dataset.status !== 'error') {
        wrapper.dataset.expanded = "true";
      }
    })

    const cardNavBtns = wrapper.querySelectorAll('[data-role="card-nav-button"]');
    cardNavBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const action = e.target.dataset.action;
        const card = wrapper.querySelector('.card')
        if (action === 'collapse') {
          wrapper.dataset.expanded = "false"
        } else if (action === 'open-menu') {
          card.dataset.menuActive = "true"
        } else if (action === 'close-menu') {
          card.dataset.menuActive = "false"
        }
      })
    })

    const controlBtns = wrapper.querySelectorAll('[data-role="player-control"]');
    controlBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const action = e.target.dataset.action;
        if (action === 'toggle-playback') {
          if (!sonikit.player.user_interacted || !sonikit.player.state) {
            sonikit.player.play(0,0)
          } else {
            sonikit.player.togglePlayback();
          }
        } else if (action === 'seek-prev') {
          sonikit.player.seekPrev()
        } else if (action === 'seek-next') {
          sonikit.player.seekNext()
        }
      })
    })

    const disconnect = wrapper.querySelector('[data-action="disconnect"]')
    disconnect.addEventListener('click', () => {
      sonikit.player.disconnect();
      clearSessions(sonikit.player);

      wrapper.dataset.status = 'disconnected'

      const card = wrapper.querySelector('.card')
      card.dataset.menuActive = "false"
      wrapper.dataset.expanded = "false"

      title.innerHTML = 'Audio disconnected';
      subtitle.innerHTML = '';
      artworkImage.src = '';
      cardArtworkImage.src = '';
      cardTitle.innerHTML = 'Audio disconnected';
      cardSubtitle.innerHTML = '';

      wrapper.remove();
    })
  }
}

customElements.define('sonikit-player', SonikitPlayer);